:host {
  display: block;
}

.pagination-display {
  opacity: 0.8;
}
